import { render, staticRenderFns } from "./TrancheInvest.vue?vue&type=template&id=8497f2f2&"
import script from "./TrancheInvest.vue?vue&type=script&lang=js&"
export * from "./TrancheInvest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports